import TypingHero from './TypingHero';

export default TypingHero;



// WEBPACK FOOTER //
// ./src/components/shared/TypingHero/index.js